import React, { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Card, CardBody, Nav, NavItem, NavLink } from "react-bootstrap";
import { TabContent, TabPane } from "reactstrap";
import BreadCrumbs from "../../../components/BreadCrumbs";
import ViewOrg from "./ViewOrg";
import "./index.css";
import AssignedCustomers from "./AssingedCustomers";

// Create navigation list for organization tabs
const NAV_LIST_ORGANIZATION_VIEW = [
  { id: 1, name: "Organization Details" },
  { id: 2, name: "Members" },
];

const OrganizationView = () => {
  const location = useLocation();
  const { id } = useParams<{ id: string }>();

  const [active, setActive] = useState(1);
  const toggle = (tab: number) => {
    setActive(tab);
  };

  const organization = location.state?.organization;

    const organizationName = organization?.displayName || 'View Organization';

  // Create custom name mapping for breadcrumb
  const breadcrumbNameMap = {
    [id!]: organizationName // Replace ID with organization name
  };


  return (
    <>
      <BreadCrumbs hasSubMenus={true}         customNameMap={breadcrumbNameMap}
 />
      <br />
      <Card className="organization-view-whole-card">
        <CardBody>
          {/* Tab Navigation - Using React Bootstrap Nav for visibility */}
          <Nav variant="pills" className="mb-3 organization-nav-tabs">
            {NAV_LIST_ORGANIZATION_VIEW.map((item) => (
              <NavItem key={item.id}>
                <NavLink
                  active={active === item.id}
                  onClick={() => toggle(item.id)}
                  style={{ 
                    cursor: "pointer",
                    backgroundColor: active === item.id ? "#0d6efd" : "transparent",
                    color: active === item.id ? "#ffffff" : "#6c757d",
                    fontWeight: active === item.id ? "600" : "normal"
                  }}
                >
                  {item.name}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
          
          {/* Alternative: If you want to use PillNavigation component */}
          {/* <div className="organization-view-nav-bar">
            <PillNavigation
              navList={NAV_LIST_ORGANIZATION_VIEW}
              active={active}
              toggle={toggle}
            />
          </div> */}
          
          <hr />
          
          {/* Tab Content */}
          <TabContent activeTab={active} className="mt-4">
            <TabPane tabId={1} className={active === 1 ? "active" : ""}>
              {active === 1 && (
                <div className="sub-nav-bar-each-part">
                  <ViewOrg organization={organization} organizationId={id} />
                </div>
              )}
            </TabPane>
            
            <TabPane tabId={2} className={active === 2 ? "active" : ""}>
              {active === 2 && (
                <div className="sub-nav-bar-each-part">
                  <AssignedCustomers 
                    organization={organization} 
                    organizationId={id} 
                  />
                </div>
              )}
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    </>
  );
};

export default OrganizationView;